import { render } from "./ServiceCopyEditingProofreading.vue?vue&type=template&id=7bc87f54"
import script from "./ServiceCopyEditingProofreading.vue?vue&type=script&lang=js"
export * from "./ServiceCopyEditingProofreading.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__